/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';

const  checkSummary =  (data) => {

  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.checkSummary.url+"/"+data.project_ID,
        maverickPortalApiEndPoint.checkSummary.methodType,
        data
      )
      .then(response => {        
        const res = response.data;
        resolve({ res });
      });
  });
};



export { checkSummary};
